import { apiClient } from './client';
import { Material } from '../types/material';

/**
 * Get all materials from the catalog
 * Materials are sorted with MATERIAUX category first
 */
export const getMaterials = async (): Promise<Material[]> => {
  const response = await apiClient.get<Material[]>('/materials');
  return response;
};
